// eslint-disable-next-line
import React from "react"
import CButton from 'Utils/Helpers/CButton';
import { HandleLogin } from 'Utils/Helpers/HandleLogin';
import Inputer from 'Utils/Helpers/Inputer';
import * as icons from 'react-bootstrap-icons';
import { useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { useSetState } from 'Utils/Helpers/Hooks';
import { initUser } from "Utils/Helpers/Token";
import { login_user } from "http/components/AuthService";
import { enqueueSnackbar } from "notistack";
import logo from "../../Styles/Images/logo512.png";

export default function UserBox({ setLoading, server}) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [controls, setControls] = useSetState ({
        username: {
            id: "username",
            type: 'text',
            placeholder: 'نام کاربری',
            value: '',
            icon: <icons.PersonBoundingBox/>,
        },
        password: {
            id: "password",
            type: 'password',
            placeholder: 'رمز عبور',
            value: '',
            icon: <icons.Key/>,
        },
    });
    const setControlsValue = (name, value) => {
        setControls({ [name]: { value: value } });
    }
    const handleLogin = async () => {
        setLoading(true);
        const { username, password } = controls;
        if(username.value !== '' && password.value !== '') {
            const params = {
                username: username.value,
                password: password.value,
            };
            const response = await login_user(params);
            setLoading(false);
            if(response.status) {
                if(response.data.token && response.data.id){
                    initUser(response.data);
                    dispatch(HandleLogin(navigate));
                } else {
                    enqueueSnackbar('در ورود به سیستم خطایی پیش آمده است', {variant: 'error'});
                }
            } else {
                enqueueSnackbar('نام کاربری یا رمز عبور صحیح نمی‌باشد', {variant: 'error'});
            }
        } else {
            setLoading(false);
            enqueueSnackbar('نام کاربری یا رمز عبور را وارد نمایید', {variant: 'error'});
        }
    }

    return (
        <div className='login-box flex-column-center-center'>
            <div className='logo-head flex-row-center-center'>
                <img src={logo} alt="user-box-logo" href="System Logo" className="h-100"/>
                {/* <icons.PersonFill size={70} color='white'/> */}
            </div>
            <div className='h-auto text-center mb-4 flex-column-between-center' style={{minHeight: '50px'}}>
                <div className="flex-row-center-center">
                    <span>{"به سیستم مدیریت مطب"}</span>
                    <strong className="text-success mx-2">{"آرما"}</strong>
                    <span>{"خوش آمدید"}</span>
                </div>
                <small>برای ورود به سیستم نام کاربری و رمز عبور خود را وارد کنید</small>
            </div>
            <div className='w-100 mb-4 flex-column-between-center' style={{minHeight: '90px'}}>
                {
                    Object.keys(controls).map((key, index) => {
                        return (
                            <Inputer
                                key={`inputer_${controls[key].id}`}
                                id={controls[key].id}
                                type={controls[key].type}
                                placeholder={controls[key].placeholder}
                                value={controls[key].value}
                                setValue={setControlsValue.bind(this)}
                                icon={controls[key].icon}
                                className={'mb-2'}
                                disabled={server === 1 || server === 2}
                                onKeyEnterActive={true}
                                onKeyEnter={handleLogin}
                            />
                        )
                    })
                }
            </div>
            <CButton
                text={'ورود به سیستم'}
                icon={<icons.BoxArrowInRight/>}
                onClick={handleLogin}
                disabled={server === 1 || server === 2}
            />
        </div>
    );
}